// extracted by mini-css-extract-plugin
export default {"child":"_child_++TLhx","trash":"_trash_vuUKO-"};